export enum OnboardingTaskStatus {
  PENDING = 'pending',
  COMPLETED = 'completed'
}

export interface OnboardingSubtask {
  id: string;
  title: string;
  completed: boolean;
  position: number;
}

export interface OnboardingTask {
  id: string;
  title: string;
  status: OnboardingTaskStatus;
  position: number;
  subtasks: OnboardingSubtask[];
  createdAt: string;
  updatedAt: string;
  userId: string;
}

export interface GroupedOnboardingTasks {
  pending: OnboardingTask[];
  completed: OnboardingTask[];
}

export interface OnboardingTasksResponse {
  tasks: GroupedOnboardingTasks;
}
